module.exports = __webpack_public_path__ + "img/comprehensive2.9dd6d3f3.webp";